import React from "react";

import Select from "react-select";
import {Loading} from "store-fetch-wrappers/dist";
import {PulseStaffDropdown, useStaffDropdown} from "./Hooks/useStaffDropdown";

/** Dropdown that will show all users assigned in an entry or all users in the database. */
const StaffDropdown = (props: PulseStaffDropdown) => {
    const {staffOptions, handleStaffChange, selectedOption, staffListStore} =
        useStaffDropdown(props);
    return (
        <React.Fragment>
            {staffListStore.loading ? (
                <Loading type={"three-ring"} showLoadingText={false} />
            ) : (
                <Select
                    className="search-bar"
                    classNamePrefix="select-options"
                    options={staffOptions}
                    onChange={handleStaffChange}
                    isSearchable={props.searchable}
                    value={selectedOption}
                    noOptionsMessage={() => "No Staff Members Found"}
                    placeholder="Select Staff Member"
                    isDisabled={props.disabled}
                    isClearable={props.clearable}
                    menuPortalTarget={document.body}
                />
            )}
        </React.Fragment>
    );
};

export default StaffDropdown;
